var e = require("react"),
  t = function (e) {
    this.fn = e, this.subscribers = [], this.cachedValue = null, this.name = e.name || "Store";
  };
t.prototype.getCachedValue = function () {
  return this.cachedValue;
}, t.prototype.useValue = function () {
  return this.cachedValue = this.fn(), this.cachedValue;
}, t.prototype.subscribe = function (e) {
  var t = this;
  return this.subscribers = this.subscribers.concat([e]), function () {
    t.subscribers = t.subscribers.filter(function (t) {
      return t !== e;
    });
  };
}, t.prototype.notify = function () {
  var e = this;
  this.subscribers.forEach(function (t) {
    return t(e.cachedValue);
  });
};
var r = function () {
  this.stores = new Map(), this.subscribers = [];
};
r.prototype.onStoresChanged = function (e) {
  var t = this;
  return this.subscribers = this.subscribers.concat([e]), function () {
    t.subscribers = t.subscribers.filter(function (t) {
      return t !== e;
    });
  };
}, r.prototype.createStore = function (e) {
  if (this.stores.has(e)) throw new Error("Store already exist");
  var r = new t(e);
  return this.stores.set(e, r), this.notifyStoresChanged(), r;
}, r.prototype.getStore = function (e) {
  if (!this.stores.has(e)) throw new Error("Store doesn't exist");
  return this.stores.get(e);
}, r.prototype.notifyStoresChanged = function () {
  this.subscribers.forEach(function (e) {
    return e();
  });
}, r.prototype.getStoresArray = function () {
  var e = [];
  return this.stores.forEach(function (t) {
    e.push(t);
  }), e;
};
var n = new r(),
  u = function () {
    return n;
  },
  o = Object.prototype.hasOwnProperty;
function s(e, t) {
  return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
}
function i(e, t) {
  if (s(e, t)) return !0;
  if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
  var r = Object.keys(e),
    n = Object.keys(t);
  if (r.length !== n.length) return !1;
  for (var u = 0; u < r.length; u++) if (!o.call(t, r[u]) || !s(e[r[u]], t[r[u]])) return !1;
  return !0;
}
var a = e.createContext(null),
  c = function (t) {
    var r = t.children;
    return e.createElement(a.Provider, {
      value: u()
    }, e.createElement(e.Fragment, null, e.createElement(h, null), r));
  };
Object.defineProperty(c, "displayName", {
  value: "ReusableProvider"
});
var f = new Map(),
  l = function () {
    var t = e.useContext(a);
    if (null === t) throw new Error("Are you trying to use Reusable without a ReusableProvider?");
    return t;
  },
  h = function () {
    var t = l(),
      r = e.useState(function () {
        return t.getStoresArray();
      }),
      n = r[0],
      u = r[1];
    return e.useEffect(function () {
      return t.onStoresChanged(function () {
        u(t.getStoresArray());
      });
    }, []), e.createElement(e.Fragment, null, n.map(function (t, r) {
      var n = function (t) {
        if (!f.has(t)) {
          var r = e.memo(function () {
            return t.useValue(), e.useEffect(function () {
              return t.notify();
            }, [t.cachedValue]), null;
          });
          Object.defineProperty(r, "name", {
            value: t.name
          }), f.set(t, r);
        }
        return f.get(t);
      }(t);
      return e.createElement(n, {
        key: r,
        store: t
      });
    }));
  };
Object.defineProperty(h, "displayName", {
  value: "Stores"
});
var b = function (e) {
  return e;
};
exports.Store = t, exports.Container = r, exports.createContainer = function () {
  return new r();
}, exports.getContainer = u, exports.replaceContainer = function (e) {
  return n = e;
}, exports.ReusableProvider = c, exports.createStore = function (t) {
  var r = u().createStore(t);
  return function (n, u) {
    return e.useDebugValue(r.name), function (t, r, n) {
      var u = l().getStore(t);
      e.useDebugValue("reusable");
      var o = e.useState(function () {
          return r(u.getCachedValue());
        }),
        s = o[0],
        i = o[1];
      return e.useEffect(function () {
        return u.subscribe(function (e) {
          var t = r(e);
          n(t, s) || i(function () {
            return t;
          });
        });
      }, [u, s, r, n]), s;
    }(t, n || b, u || i);
  };
};